import React from "react";

import { Banner } from "../../components/Banner/Banner";
class LandingPage extends React.Component {
  render(): React.ReactNode {
    return (
      <>
        <Banner />
      </>
    );
  }
}

export default LandingPage;
